<template>
    <div v-if="hasAccess">
        <top-nav-bar goto="/?page=reports">
            <router-link to="/reports" tag="button"
                         class="h-full items-center flex bg-secondary absolute pin-t pin-r mr-2 text-white font-bold font-heading uppercase">
                <i class="fas fa-plus mr-2"></i>
                File Report
            </router-link>
        </top-nav-bar>

        <div v-if="!loading" class="py-2">
            <div v-if="hasMonths()">
                <div v-for="(reports, month) in months" :key="month" class="mb2">
                    <h3 class="text-center">{{ getMonthName(month) }}</h3>
                    <list>
                        <list-item url="#" v-for="report in reports" :key="report.id" @click.native.prevent
                                   @click="navigateTo(report)">
                            <template slot="icon">
                                <icon :icon="report.icon" :classes="report.color + ' w-6 h-6'"></icon>
                            </template>
                            <template slot="title">{{ report.type.name }}</template>
                            <template slot="sub-title">{{ formatDate(report.created) }}</template>
                            <template slot="status">
                                <icon :icon="report.completed ? 'fas fa-check' : 'fas fa-redo-alt'"
                                      :classes="(report.completed ? 'text-green' : 'text-blue') + ' w-6 h-6'"></icon>
                            </template>
                        </list-item>
                    </list>
                </div>
            </div>
            <div class="text-center p-4 text-grey-dark" v-if="!hasMonths()">
                You currently have no stored reports.
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import {size} from 'lodash'
import InteractsWithDates from '@/mixins/InteractsWithDates'
import CanAccessView from "../mixins/CanAccessView";

export default {
    mixins: [InteractsWithDates, CanAccessView],

    data() {
        return {
            loading: true,
            months: {}
        }
    },

    computed: {},

    mounted() {
        this.$api('hr').get('reports')
            .then(({data}) => {
                this.months = data.data
                this.loading = false
            })
    },

    methods: {
        navigateTo(report) {
            this.$router.push('/reports/' + report.id)
        },

        hasMonths() {
            return size(this.months)
        },

        getMonthName(month) {
            return moment(month, 'YYYY-MM').format('MMMM YYYY')
        },
    },
}
</script>
